import React, { useState } from "react";
import { supabase } from "../../services/supabase";
import { useNavigate } from "react-router-dom";

export default function Signup() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [businessType, setBusinessType] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      console.log("Starting signup process...");
      
      // 1. Create Supabase auth user
      const { data: authData, error: authError } = await supabase.auth.signUp({
        email,
        password,
      });
      
      if (authError) {
        console.error('Auth error:', authError);
        throw authError;
      }
      
      console.log("Auth user created:", authData.user.id);

      // 2. Create Stripe Connect account using the server endpoint
      const businessDetails = {
        email,
        name: businessName,
        businessType: businessType
      };

      console.log("Business details being sent:", {
        email,
        name: businessName,
        businessType: businessType
      });
      
      const response = await fetch("/account", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId: authData.user.id,
          businessDetails
        }),
      });
      
      const accountData = await response.json();
      console.log("Response from server:", accountData);
      console.log("Account type:", accountData.accountType);
      console.log("Account link URL:", accountData.accountLink);

      if (!response.ok) {
        throw new Error(accountData.error || 'Failed to create Stripe account');
      }
      
      console.log("Stripe account created:", accountData.account);

      if (accountData.accountLink) {
        console.log("Redirecting to:", accountData.accountLink);
        window.location.href = accountData.accountLink;
        return; // Important to stop execution
      }
      
      const { data: existingProfile } = await supabase
        .from('user_profiles')
        .select('*')
        .eq('user_id', authData.user.id)
        .single();
        
      if (!existingProfile) {
        console.log("Creating user profile as fallback");
        const { error: dbError } = await supabase
          .from('user_profiles')
          .insert({
            user_id: authData.user.id,
            stripe_connect_id: accountData.account,
            stripe_account_status: 'pending',
            stripe_account_type: accountData.accountType || 'standard',
            business_name: businessName,
            created_at: new Date(),
            updated_at: new Date()
          });
          
        if (dbError) {
          console.error('Database error:', dbError);
        }
      }
      
      const { error: signInError } = await supabase.auth.signOut();
      if (signInError) {
        console.error("Error signing out:", signInError);
      }
      
      const { error: loginError } = await supabase.auth.signInWithPassword({
        email,
        password,
      });
      
      if (loginError) {
        console.error("Error signing in:", loginError);
        throw loginError;
      }
      
      console.log("Signup complete, navigating to dashboard");
      navigate("/dashboard");
    } catch (error) {
      console.error('Signup error:', error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="banner">
        <h2>QR Butler</h2>
      </div>
      <div className="content">
        <h2>Create an account</h2>
        <p>Sign up to start accepting payments with Stripe Connect</p>
        
        {error && <p className="error">{error}</p>}
        
        <form onSubmit={handleSignup} style={{ width: '100%' }}>
          <div style={{ marginBottom: '15px', textAlign: 'left' }}>
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                width: '100%',
                padding: '8px',
                marginTop: '5px',
                borderRadius: '4px',
                border: '1px solid #ddd'
              }}
              required
            />
          </div>
          
          <div style={{ marginBottom: '15px', textAlign: 'left' }}>
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: '100%',
                padding: '8px',
                marginTop: '5px',
                borderRadius: '4px',
                border: '1px solid #ddd'
              }}
              required
            />
          </div>

          <div style={{ marginBottom: '15px', textAlign: 'left' }}>
            <label>Business Name</label>
            <input
              type="text"
              value={businessName}
              onChange={(e) => setBusinessName(e.target.value)}
              style={{
                width: '100%',
                padding: '8px',
                marginTop: '5px',
                borderRadius: '4px',
                border: '1px solid #ddd'
              }}
              required
            />
          </div>

          <div style={{ marginBottom: '15px', textAlign: 'left' }}>
            <label>Business Type</label>
            <select
              value={businessType}
              onChange={(e) => setBusinessType(e.target.value)}
              style={{
                width: '100%',
                padding: '8px',
                marginTop: '5px',
                borderRadius: '4px',
                border: '1px solid #ddd'
              }}
              required
            >
              <option value="">Select Type</option>
              <option value="individual">Individual</option>
              <option value="company">Company</option>
            </select>
          </div>
          
          <button 
            type="submit" 
            disabled={loading}
            style={{
              backgroundColor: '#635BFF',
              color: 'white',
              border: 'none',
              padding: '12px 20px',
              borderRadius: '6px',
              fontSize: '16px',
              fontWeight: '500',
              cursor: loading ? 'wait' : 'pointer',
              width: '100%',
              opacity: loading ? 0.7 : 1
            }}
          >
            {loading ? "Creating account..." : "Sign Up"}
          </button>
        </form>
        
        <p style={{ marginTop: '15px' }}>
          Already have an account? <a href="/login">Login</a>
        </p>
      </div>
    </div>
  );
}
